import * as React from "react";
import type { SVGProps } from "react";
const SvgSortVertical02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13.442 6.627H22m-8.558 4.815h6.113m-6.113 4.815h3.667M5.806 6v12m0 0L2 14.332M5.806 18l3.95-3.668"
    />
  </svg>
);
export default SvgSortVertical02;
